import { ButtonLink } from "@/components/button-link";
import { ArrowIcon } from "@/components/icon";
import { Logo } from "@/components/logo";
import config from "@/config";

export function FinalCta() {
	return (
		<section data-slot="final" data-surface="inverse">
			<div data-slot="final-inner">
				<Logo />
				<h2 data-slot="final-title">
					O dia da obra, <em>registrado.</em>
				</h2>
				<p data-slot="final-text">
					Pare de montar o Relatório de Obra à noite. Deixe o canteiro contar o
					dia enquanto ele acontece.
				</p>
				<ButtonLink href={config.app.waitlistURL}>
					Entrar na lista de espera <ArrowIcon />
				</ButtonLink>
				<span data-slot="final-domain">obratododia.com.br</span>
			</div>
		</section>
	);
}
